import { msAPI, osAPI } from "./index.js";

export const editProducts = async (payload) => {
  return (await msAPI.post("merchant/product", payload)).data;
};

export const bulkSetProductInactive = async (payload) => {
  return (await msAPI.patch("merchant/products/inactive", payload)).data;
};

export const getOrderByID = async (id) => {
  return (await osAPI.get(`merchant/orders/${id}`)).data;
};

export const acceptOrder = async (id) => {
  return (await osAPI.post(`merchant/orders/${id}/accept`)).data;
};

export const getAvailableCategories = async () => {
  return (await msAPI.get("merchant/available-categories")).data;
};

export const createCustomProduct = async (product) => {
  return (await msAPI.post("merchant/custom-product", product)).data;
};

export const updateCustomProduct = async (sku_id, product) => {
  return (await msAPI.patch(`merchant/custom-product/${sku_id}`, product)).data;
};

export const getPricing = async (skus) => {
  return (await msAPI.get("merchant/products/pricing", {
    params: { skus: skus.join(",") },
  })).data;
};

export const getMultipleProductCategoryAssignments = async (skus) => {
  return (await msAPI.get("merchant/products/categories", {
    params: { skus: skus.join(",") },
  })).data;
};

export const getCustomProduct = async (sku_id) => {
  return (await msAPI.get(`merchant/custom-product/${sku_id}`)).data;
};

export const getCustomCategories = async () => {
  return (await msAPI.get("merchant/custom-categories")).data;
};

export const getCustomCategoryByID = async (category_id) => {
  return (await msAPI.get(`merchant/custom-category/${category_id}`)).data;
};

export const reorderCustomCategories = async (ordinals) => {
  return (await msAPI.post("merchant/custom-categories-ordinal", { ordinals })).data;
};

export const reorderFeaturedProductsInCustomCategory = async (
  category_id,
  ordinals
) => {
  return (await msAPI.post(`merchant/custom-category/${category_id}/featured-products`, { ordinals })).data;
};

export const updateCustomCategoryName = async (category_id, name) => {
  return (await msAPI.patch(`merchant/custom-category/${category_id}/name`, { name })).data;
};

export const updateCustomCategoryHidden = async (category_id, hidden) => {
  return (await msAPI.patch(`merchant/custom-category/${category_id}/hidden`, { hidden })).data;
};

export const createCustomCategory = async (name) => {
  return (await msAPI.post("merchant/custom-category", { name })).data;
};

export const createCustomDynamicCategory = async (name, search) => {
  return (await msAPI.post("merchant/custom-dynamic-category", { name, search })).data;
};

export const updateCustomDynamicCategory = async (category_id, search) => {
  return (await msAPI.patch(`merchant/custom-dynamic-category/${category_id}`, { search })).data;
};

export const getProductCategoryAssignment = async (sku_id) => {
  return (await msAPI.get(`merchant/product/${sku_id}/custom-category-assigment`)).data;
};

export const bulkChangeCustomCategoryAssignment = async (
  sku_ids,
  category_ops
) => {
  return (await msAPI.post("merchant/products/custom-category-assignment", { sku_ids, category_ops })).data;
};

export const deleteCustomCategory = async (category_id) => {
  return (await msAPI.delete(`merchant/custom-category/${category_id}`)).data;
};
